import { RoleApiUrls } from './../../user/constants/role-api-url.constant';
import { Injectable } from '@angular/core';
import { HttpService } from '../../core/http/http.service';
import { LogService } from '../../core/logger/services/log.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SharedHeaders, ContentTypes } from '../../shared/constants/shared.constants';
import {
  AuthenticationConstants,
  AuthenticationHeaders,
  AuthenticationRoutes,
  AuthenticationMessages,
  UserRoles
} from '../constants/authentication.constants';
import { JwtDecodeService } from '../../core/jwt-decode/jwt-decode.service';
import { TokenInfo } from '../interfaces/token-info.interface';
import { map, tap } from 'rxjs/operators';
import { AuthenticationService } from '../state/authentication.service';
import { AuthenticationQuery } from '../state/authentication.query';
import { UserInfo } from '../interfaces/user-info.interface';
import { ChangePassword } from '../interfaces/change-password.interface';
import { LayoutUrls } from '../../layout/constants/layout.constants';
import { Observable } from 'rxjs';
import { CaptchaVerification } from '../interfaces/captcha-verification.interface';
import { SmsResponse } from '../../user-registration/models/sms-response.model';
import { AuthenticationStore } from '../state/authentication.store';
import { UserRegistrationRoutes } from '../../user-registration/constants/user-registration.api-routes-constant';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationHttpService {

  constructor(
    private logger: LogService,
    private http: HttpService,
    private jwtDecode: JwtDecodeService,
    private authenticationService: AuthenticationService,
    private authenticationQuery: AuthenticationQuery,
    private _httpClient: HttpClient,
    private authenticationStore: AuthenticationStore) { }

  login(userName: string, password: string) {

    const headers = new HttpHeaders();
    headers.append(SharedHeaders.ContentType, ContentTypes.xwwwformurlencoded);

    const params = new HttpParams()
      .set(AuthenticationHeaders.UserName, userName)
      .set(AuthenticationHeaders.Password, password)
      .set(AuthenticationHeaders.GrantType, AuthenticationConstants.token.grant_type)
      .set(AuthenticationHeaders.ClientId, AuthenticationConstants.token.client_id);

    return this.http.post<TokenInfo>(AuthenticationRoutes.Login(), params, true, headers)
      .pipe(tap((tokenInfo: TokenInfo) => {
        this.logger.debug(AuthenticationMessages.LoginSuccess, tokenInfo);
        this.logger.debug(AuthenticationMessages.DecodedToken, this.jwtDecode.decode(tokenInfo.access_token));
        this.authenticationService.login(tokenInfo);
      }));
  }

  getUserInfo() {
    return this.http.get<UserInfo>(AuthenticationRoutes.UserInfo())
      .pipe(tap((userInfo: UserInfo) => {
        this.http.get<string[]>(RoleApiUrls.userroles).subscribe((response: string[]) => {
          localStorage.setItem(UserRoles.Roles, JSON.stringify(response));
          this.authenticationService.updateAuthenticationState({ userInfo });
        });

      }));
  }
  changePassword(changePassword: ChangePassword) {
    return this.http.post<boolean>(LayoutUrls.ChangePassword, changePassword);
  }

  verifyPassword(password: string) {
    return this.http.post<boolean>(LayoutUrls.VerifyPassword, { password });
  }

  verifyCaptcha(captcha: { captchaResponse: string }) {
    return this.http.post<CaptchaVerification>(AuthenticationRoutes.CaptchVerify(), captcha);
  }

  saveToken(accessToken: string) {
    return this.http.post(AuthenticationRoutes.SaveToken(), accessToken);
  }

  MFAVerify(payload: any): Observable<SmsResponse> {
    return this.http.post<SmsResponse>(AuthenticationRoutes.MFAverify, payload);
  }

  verify(guid: string, details: { mobileNumber: string; email: string }): Observable<SmsResponse> {
    return this.http.post<SmsResponse>(`${AuthenticationRoutes.verify}/${guid}`, details);
  }

  MFAotpVerify(guid: string, tokenCode: string, MFA: string, MFARequestType: string) {
    return this.http.post(AuthenticationRoutes.MFAotpVerify(guid, tokenCode, MFA, MFARequestType));
  }

  otpVerify(guid: string, tokenCode: string) {
    return this.http.post(AuthenticationRoutes.otpVerify(guid, tokenCode));
  }

  setMfaVerified(flag: boolean) {
    this.authenticationStore.update({ mfaVerified: flag });
  }

  getUserTiles(userId: string): Observable<string[]> {
    return this.http.get<string[]>(`/api/user/${userId}/tiles`);
  }

  resendOtp(identifier: string, MFARequestType?: number) {
    return this.http.get<SmsResponse>(UserRegistrationRoutes.resentOtp(identifier, MFARequestType));
  }

  getEnableMFA(): Observable<boolean> {
    return this.http.get<boolean>('/api/featureflags/enableMFA');
  }

  GetUserRegionsAsync(userId: string): Observable<string[]> {
    return this.http.get<string[]>(`/api/user/${userId}/userRegion`);
  }

  GetUserOrganisationsAsync(userId: string, regionId: number): Observable<string[]> {
    return this.http.get<string[]>(`/api/user/${userId}/${regionId}/UserOrganisation`);
  }
}
